import { render } from "./NotFound.vue?vue&type=template&id=68d29710&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=68d29710&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68d29710"

export default script